import {
  AuctionFilledIcon,
  ErrorFilledIcon,
  Status,
  theme
} from '@kvdbil/components';
import React from 'react';
import styled from 'styled-components';

import { useTranslation } from '~/Locale';
import AuctionResultStatus from '../AuctionResultStatus';
import { AuctionType } from '~/App/shared/types/AuctionType';

const Container = styled.div`
  width: 100%;
  margin-top: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const IconContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.primary.mainAlt};
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const StyledStatus = styled(Status)`
  font-size: 16px;
  margin-left: 1rem;
`;

type Props = {
  isWinner: boolean;
  isParticipating: boolean;
  isLeading: boolean;
  isClosed: boolean;
  reservationPriceReached: boolean;
  isSoldByBuyNow: boolean;
  buyMethod: AuctionType;
};

function AuctionStatusForBuyMethod({
  isWinner,
  isParticipating,
  isLeading,
  isClosed,
  reservationPriceReached,
  isSoldByBuyNow,
  buyMethod
}: Props) {
  const { t } = useTranslation();
  const isBuyNow = buyMethod === 'BUY_NOW';

  return (
    <Container>
      {!isLeading && isParticipating && !isClosed && !isBuyNow && (
        <>
          <ErrorFilledIcon
            height={'40px'}
            width={'40px'}
            color={theme.colors.tertiary.mainAlt}
          />
          <StyledStatus>{t('You have been overbidded')}!</StyledStatus>
        </>
      )}

      {isLeading && !isClosed && !isBuyNow && (
        <>
          <IconContainer>
            <AuctionFilledIcon
              height={'24px'}
              width={'24px'}
              color={theme.colors.primary.lighter2}
            />
          </IconContainer>
          <StyledStatus>{t('You are winning')}!</StyledStatus>
        </>
      )}

      {isClosed && (
        <AuctionResultStatus
          reservationPriceReached={reservationPriceReached}
          isWinner={isWinner}
          isSoldByBuyNow={isSoldByBuyNow}
        />
      )}
    </Container>
  );
}

export default AuctionStatusForBuyMethod;
